import { render, staticRenderFns } from "./ProjectRecycle.vue?vue&type=template&id=08914036&scoped=true&"
import script from "./ProjectRecycle.vue?vue&type=script&lang=ts&"
export * from "./ProjectRecycle.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectRecycle.vue?vue&type=style&index=0&id=08914036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08914036",
  null
  
)

export default component.exports